import { Injectable } from '@angular/core';
import { Part } from './part';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PartService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Part[]> {
    return this.httpClient.get<Part[]>(this.baseUrl + 'api/PartApi')
  }
  Post(part: Part): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/PartApi/add', part, { headers: header, observe: 'response' })
  }
  Delete(part: Part) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/PartApi/activeordeactive', part, { headers: header, observe: 'response' })
  }
  Put(part: Part): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/PartApi/Update', part, { headers: header, observe: 'response' })
  }


}
